
export default function TeamSection() {
  const teamMembers = [
    {
      name: '张茶韵',
      position: '创始人兼CEO',
      image: 'https://public.readdy.ai/ai/img_res/e27619a96ea24653fa389818b44e0469.jpg',
      description: '30年茶行业经验，国家级茶叶审评师，致力于推动年份茶行业标准化发展。'
    },
    {
      name: '李品质',
      position: '技术总监',
      image: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20tea%20quality%20control%20director%20portrait%2C%20middle-aged%20man%20in%20professional%20attire%2C%20knowledgeable%20and%20focused%20expression%2C%20tea%20laboratory%20background%2C%20professional%20corporate%20lighting%2C%20business%20headshot%20photography%20style&width=300&height=300&seq=team-cto&orientation=squarish',
      description: '茶学博士，专注于茶叶品质控制和仓储技术研发，拥有多项茶叶保存技术专利。'
    },
    {
      name: '王传承',
      position: '供应链总监',
      image: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20tea%20supply%20chain%20director%20portrait%2C%20mature%20man%20in%20business%20casual%20attire%2C%20reliable%20and%20experienced%20expression%2C%20tea%20plantation%20background%2C%20natural%20professional%20lighting%2C%20corporate%20portrait%20photography&width=300&height=300&seq=team-supply&orientation=squarish',
      description: '深耕云南茶区20年，与500+茶农和厂家建立深度合作关系，确保源头品质。'
    },
    {
      name: '陈匠心',
      position: '首席审评师',
      image: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20tea%20master%20evaluator%20portrait%2C%20senior%20expert%20in%20traditional%20Chinese%20clothing%2C%20wise%20and%20experienced%20expression%2C%20traditional%20tea%20ceremony%20setting%2C%20warm%20ambient%20lighting%2C%20artistic%20portrait%20photography%20style&width=300&height=300&seq=team-evaluator&orientation=squarish',
      description: '国家一级茶叶审评师，40年品茶经验，对年份茶品质有独到见解和严格标准。'
    }
  ];

  return (
    <section className="py-16 bg-[#f5f5f5]">
      <div className="mx-auto px-6 lg:px-[15%]">
        <div className="text-center mb-12">
          <h2 className="text-2xl sm:text-4xl lg:text-5xl xl:text-6xl font-bold text-[#663333] mb-4">
            核心团队
          </h2>
          <p className="text-sm sm:text-lg text-gray-600">
            汇聚行业精英，用专业成就品质
          </p>
          <div className="w-24 h-1 bg-[#cc9966] mx-auto mt-4"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {teamMembers.map((member, index) => (
            <div key={index} className="bg-white rounded-2xl p-6 shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 border border-[#cc9966]/20 text-center">
              <div className="mb-6">
                <img
                  src={member.image}
                  alt={member.name}
                  className="w-24 h-24 rounded-full mx-auto object-cover object-top shadow-lg border-4 border-[#cc9966]/20"
                />
              </div>
              
              <h3 className="text-lg sm:text-xl font-bold text-[#663333] mb-2">
                {member.name}
              </h3>
              
              <div className="text-sm sm:text-base text-[#cc9966] font-semibold mb-4">
                {member.position}
              </div>
              
              <p className="text-xs sm:text-sm text-gray-600 leading-relaxed">
                {member.description}
              </p>
            </div>
          ))}
        </div>

        {/* 团队优势 */}
        <div className="mt-16 bg-white rounded-2xl p-8 lg:p-12 shadow-lg border border-[#cc9966]/20">
          <h3 className="text-lg sm:text-xl lg:text-2xl font-bold text-[#663333] text-center mb-8">
            团队优势
          </h3>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="text-center">
              <div className="w-16 h-16 flex items-center justify-center bg-[#cc9966] rounded-full mx-auto mb-4">
                <i className="ri-graduation-cap-fill text-2xl text-white"></i>
              </div>
              <h4 className="text-sm sm:text-base lg:text-lg font-semibold text-[#663333] mb-2">专业背景</h4>
              <p className="text-xs sm:text-sm text-gray-600">
                团队成员均拥有深厚的茶学专业背景，平均从业经验超过20年
              </p>
            </div>
            
            <div className="text-center">
              <div className="w-16 h-16 flex items-center justify-center bg-[#cc9966] rounded-full mx-auto mb-4">
                <i className="ri-lightbulb-fill text-2xl text-white"></i>
              </div>
              <h4 className="text-sm sm:text-base lg:text-lg font-semibold text-[#663333] mb-2">创新能力</h4>
              <p className="text-xs sm:text-sm text-gray-600">
                持续推动行业技术创新，拥有多项茶叶保存和品质检测专利
              </p>
            </div>
            
            <div className="text-center">
              <div className="w-16 h-16 flex items-center justify-center bg-[#cc9966] rounded-full mx-auto mb-4">
                <i className="ri-team-fill text-2xl text-white"></i>
              </div>
              <h4 className="text-sm sm:text-base lg:text-lg font-semibold text-[#663333] mb-2">协作精神</h4>
              <p className="text-xs sm:text-sm text-gray-600">
                跨部门紧密协作，确保从采购到销售每个环节的品质控制
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}